<template>
  <div class="kantei-header">
    <h2 class="kantei-header__title">
      <span class="kantei-header__title1">人気占い師による動画鑑定が</span>
      <span class="kantei-header__title2">ポイント利用で<br />無料で申し込めます。</span>
    </h2>
    <div class="kantei-header__conversion">1回<br><b>{{ consumptionPoint }}</b>pt</div>
    <div class="own-point">
      <div class="own-point__wrap">
        <div class="own-point__text">保有ポイント</div>
        <div class="own-point__point"><b>{{ userPoint }}</b>pt</div>
      </div>
    </div>
    <ul class="kantei-header__note note-list">
      <li class="note-list__item">ポイント以外での申し込みはできません。</li>
      <li class="note-list__item">
        占い師の指名はできません。占い師を指名したい場合は、別途<a href="/category/ordermade">オーダーメイド型占い（有料）</a>をご購入ください。</li>
      <li class="note-list__item">
        動画内の汎用的な解説動画のパートは、他のサブスクリプション会員向けにサイト上で公開されることがあります。<br>
      （個人が特定される情報は含まれませんので、ご安心ください。）
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "KanteiHeader",
  props: {
    consumptionPoint: {
      type: Number | String,
      default: 0
    },
    userPoint: {
      type: String,
      default: '0'
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.kantei-header {
  color: $col_base_black;
  padding: 0 0 32px;
  margin: 0 10px;
  position: relative;
  border-bottom: 1px solid #DCDFE2;
  &__title {
    font-weight: bold;
    line-height: 34px;
    margin: 0 -20px 24px;
    padding: 10px 0 0;
    text-align: center;
  }
  &__title1 {
    display: block;
    font-size: 14px;
    margin-right: 10px;
    @include mq('sp'){
      font-size: 16px;
      margin-right: 0;
    }
  }
  &__title2 {
    font-size: 25px;
    @include mq('sp'){
      font-size: 26px;
    }
  }
  &__conversion {
    color: #fff;
    font-family: din-2014, sans-serif;
    font-size: 11px;
    font-weight: bold;
    line-height: 1.25;
    margin: 0 0 10px;
    padding-top: 9px;
    position: absolute;
    top: 0;
    right: -10px;
    width: 55px;
    height: 55px;
    text-align: center;
    background: #FF7497;
    border-radius: 30px;
    transform: scale(0.9);
    transform-origin: right top;
    b {
      font-size: 16px;
      font-weight: inherit;
    }
    @include mq('sp'){
      transform: scale(1);
    }
  }
}
.own-point {
  text-align: center;
  &__wrap {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    min-width: 255px;
    min-height: 50px;
    padding: 14.5px 30px;
    margin: 0 auto 30px;
    border-radius: 100px;
    position: relative;
    z-index: 1;
    background: $col_def_gradient;
    color: #656D78;
    &::before{
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1;
      box-sizing: border-box;
      border-radius: 100px;
      margin: 2px;
      background: $col_white;
      content: "";
    }
  }
  &__text {
    font-size: 11px;
    flex: 0 0 auto;
    margin-right: 8px;
  }
  &__point {
    font-family: din-2014, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    text-align: right;
    word-break: break-all;
    b {
      font-size: 21px;
      font-weight: inherit;
    }
  }
}
.note-list {
  padding: 0;
  margin: 0;
  font-size: 11px;
  line-height: 1.5;
  text-align: justify;
  color: #656D78;
  &__item {
    display: block;
    margin: 0 0 1px;
    &:last-child {
      margin-bottom: 0;
    }
    &::before {
      content: '※';
    }
    a {
      color: inherit;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Favor/KanteiHeader.vue